import PropTypes from 'prop-types';

const DaysInQuarter = ({liveDaysInQ}) => {

  return (
    <div className='mb-[16px]'>
      <span className='text-[18px] font-semibold'>Total days live in quarter: </span>
      <span className='text-[18px] pl-4 '>{liveDaysInQ}</span>
    </div>
  )
}

export default DaysInQuarter;

DaysInQuarter.propTypes = {
	liveDaysInQ: PropTypes.number.isRequired,
};



